<button mat-icon-button
        (click)="openTagSettings()"
        matTooltip="{{ 'global.tagSettings' | translate }}"
        class="button-color-not-active"
        flex>
  <mat-icon>settings</mat-icon>
</button>
